import React, { useState, useCallback, useEffect, useRef, useMemo } from "react";
import { connect } from "react-redux";

import {
    Column,
    DataGrid,
    GroupPanel,
    Grouping,
    FilterRow,
    FilterPanel,
    Sorting,
    Paging,
    Pager,
    LoadPanel,
  Export,
  ColumnChooser,
  ColumnChooserSearch,
  ColumnHeaderFilter,
  StateStoring,
  Toolbar as GridToolbar,
  Item as GridToolbarItem,
} from "devextreme-react/data-grid";
import GridLayoutManager from "../../../gridLayoutCustomization/GridLayoutManager"
import { GridLayout } from "../../../common/GridLayout";
import { createStore } from 'devextreme-aspnet-data-nojquery';

function UnavailableTab(props) {
    const dataGrid = useRef(null);
    var accessToken = props.oidc.user.access_token;
    var currentUser = props.oidc.user;
    const gridKey = "438A91D7-6726-4259-ADE2-D08F424E41BC";
    const [currentLayout, setCurrentLayout] = useState("Default");
    const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken,null,currentLayout); }, [currentLayout]);
    const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);

    const resultData = useMemo(() => {
        if (!props.itemRowId) {
            return null;
        }
        return createStore({
            key: 'rowId',
            loadParams:
            {
                id: function () {
                    return props?.itemRowId;
                }
                ,type:props.type
            },
            loadUrl: `${window._env_.REACT_APP_APIS}/wm/Item/GetUnavailableLocations`,
            onBeforeSend: (method, ajaxOptions) => {
                ajaxOptions.headers = {
                    access_token: accessToken,
                    Authorization: `Bearer ${accessToken}`,
                };
            },
        })
    }, [props.itemRowId]);

    return (
        <div>
            <div className="alert alert-secondary" role="alert">
                <b>The "Unavailable" Tab will show records from the "IMTransactionLocation" table and will summarize records by "Warehouse, Location 
                and the Reason Code" for the above selected Item. If Total Unavailable = 0, then it will not be shown on this screen.</b>
            </div>
            <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
                ref={dataGrid}
                dataSource={resultData}
                allowColumnReordering={true}
                allowColumnResizing={true}
                showBorders={true}
                hoverStateEnabled={true}
                className={"GridHeightAccordianOpen-tabs-single-row"}
                searchEnabled={true}
                columnAutoWidth={true}
            >
                <ColumnChooser
                    enabled={true}
                    title="Choose Column"
                    width={290}
                    height={290}
                    sortOrder="asc"
                >
                    <ColumnChooserSearch
                        enabled={true}
                        editorOptions={{ placeholder: 'Search column' }} />
                </ColumnChooser>
                <FilterRow visible={true} />
                <FilterPanel visible={true} />
                <GroupPanel visible={true} />
                <Grouping autoExpandAll={false} />
                <ColumnHeaderFilter />
                <LoadPanel enabled={true} />
                <Export enabled={true} allowExportSelectedData={true} />
                <Paging defaultPageSize={10} />
                <Sorting visible={true} mode="multiple" />
                <StateStoring
                    enabled={true}
                    type="custom"
                    customLoad={loadState}
                    storageKey={gridKey}
                    customSave={saveState}
                />
                <Pager
                    visible={true}
                    showPageSizeSelector={true}
                    allowedPageSizes={[10, 20, 50, 300, 500, 'all']}
                    showNavigationButtons={true}
                />
                <Column dataField="warehouse" caption="Warehouse" dataType="string" />
                <Column dataField="locationCode" caption="Location" dataType="string" />
                <Column dataField="locationDescription" caption="Location Description" dataType="string" />
                <Column dataField="reason" caption="Reason" dataType="string" />
                <Column dataField="reasonDescription" caption="Reason Description" dataType="string" />
                <Column dataField="unavailable" caption="Unavailable" dataType="number" format={{ type: 'fixedPoint', precision: 2, useGrouping: true }} />
                <GridToolbar>
                    <GridToolbarItem location="after">
                        <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                    </GridToolbarItem>
                    <GridToolbarItem name="exportButton" />
                    <GridToolbarItem name="columnChooserButton" />
                </GridToolbar>
            </DataGrid>
        </div>
    );
}

function mapStateToProps(state) {
    return {
        ReceiptReducer: state.ReceiptReducer,
        oidc: state.oidc,
    };
}

export default connect(mapStateToProps)(UnavailableTab);